import React, { useState, useEffect } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { ToastContainer, toast } from "react-toastify";
import { Row, Col, Select, Input, Modal } from "antd";
import { API_GET_OPTIONS, API_CREATE_PLAN } from "api/plan-management";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { API_LIST_STORE } from "api/store-managemnt";
import { API_LIST_USER } from "api/customers-management";
import { API_CREATE_ORDER } from "api/order-management";
import { API_LIST_ITEM } from "api/item-management";
import { API_LIST_CATAGORY } from "api/catagory-managemnt";
import { TreeSelect } from "antd";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { API_COUPEN_ORDER } from "api/order-management";
import { Card } from "antd";
import { API_DELIVERY_ORDER } from "api/order-management";
import CreateOrderUser from "../OrderUser/CreateOrderUser";
import { CONSTANTS } from "config/constant";
import AddressAutocomplete from "components/AddressAutocomplete/AddressAutocomplete";
import TextareaField from "components/AddressAutocomplete/TextareaField";
import axios from "axios";
// import { DatePicker } from "antd";
// const { RangePicker } = DatePicker;

const { Option } = Select;

const CreateOrder = () => {
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [itemOptions, setItemOptions] = useState([]);
  const [providerOptions, setProviderOptions] = useState([]);
  const [userOptions, setUserOptions] = useState([]);
  const [loadingUser, setLoadingUser] = useState(false);
  const [searchName, setSearchName] = useState("");
  const [selectedItems, setSelectedItems] = useState();
  const [price, setPrice] = useState();

  const [paginationUser, setPaginationUser] = useState({
    current: 1,
    pageSize: 8,
    total: 0,
    totalPages: 0,
  });
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10, // adjust as needed
    totalPages: 1, // initial value, will be updated on data fetch
  });
  const [paginationItems, setPaginationItems] = useState({
    current: 1,
    pageSize: 10, // adjust as needed
    totalPages: 1, // initial value, will be updated on data fetch
  });
  const [paginationCatagories, setPaginationCatagories] = useState({
    current: 1,
    pageSize: 10, // adjust as needed
    totalPages: 1, // initial value, will be updated on data fetch
  });
  const [modalVisible, setModalVisible] = useState(false);
  const [couponData, setCouponData] = useState(null);
  const [deliveryFee, setDeliveryFee] = useState(null);
  const [autocompleteSuggestions, setAutocompleteSuggestions] = useState([]);
  const [autocompleteSuggestionsDelevery, setAutocompleteSuggestionsDelevery] =
    useState([]);
  const [startDatePickup, setStartDatePickup] = useState(null);
  const [endDatePickup, setEndDatePickup] = useState(null);
  const [startDateDelivery, setStartDateDelivery] = useState(null);
  const [endDateDelivery, setEndDateDelivey] = useState(null);
  const handleApplyCoupon = async (coupon_code, total_amount) => {
    try {
      const payload = {
        coupon_code: coupon_code,
        total_amount: price,
      };

      const response = await API_COUPEN_ORDER(payload);
      setCouponData(response?.discounted_amount);
      toast.success("Coupon applied successfully!");
    } catch (error) {
      console.error("Error applying coupon:", error);
      toast.error(error?.response?.data?.error);
    }
  };
  const handleModalOpen = () => {
    setModalVisible(true);
  };

  const { t } = useTranslation();
  const navigate = useNavigate();

  const fetchUserList = async (page = 1, pageSize = 8) => {
    console.log("page ==>", page, pageSize);
    try {
      setLoadingUser(true);
      const params = {
        page,
        limit: pageSize,
      };
      const response = await API_LIST_USER(params);
      const { users, totalPages, totalUsers } = response; // Adjusting according to API response
      setUserOptions((prevUserList) => [...prevUserList, ...users]);
      setPaginationUser((prevPagination) => ({
        ...prevPagination,
        current: page,
        total: totalUsers,
        totalPages: totalPages,
      }));
      setLoadingUser(false);
    } catch (error) {
      console.error("Error fetching users:", error);
      setLoadingUser(false);
    }
  };

  const fetchData = async (page) => {
    try {
      setLoading(true);
      const params = {
        page: page,
        limit: pagination.pageSize,
        name: "",
      };
      const newData = await API_LIST_STORE(params);
      setProviderOptions((prevData) => [...prevData, ...newData.providers]);
      setPagination((prevPagination) => ({
        ...prevPagination,
        totalPages: newData.total_pages,
      }));
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchDataItems = async () => {
    try {
      return
      setLoading(true);
      const params = {
        page: paginationItems.current,
        limit: paginationItems.pageSize,
        category: searchName,
      };
      const newData = await API_LIST_ITEM(params);
      console.log("provider", newData);
      setItemOptions(newData);
      // setLoading(false);
      setPaginationItems({ ...pagination, total: newData.total_items }); // Assuming API response contains total count
    } catch (error) {
      console.error("Error fetching data:", error);
      // setLoading(false);
    }
  };
  const fetchDataCatagories = async () => {
    try {
      setLoading(true);
      const params = {
        page: pagination.current,
        limit: pagination.pageSize,
        // name: searchName,
      };
      const newData = await API_LIST_CATAGORY(params);
      console.log("provider", newData);
      setCategoryOptions(newData);
      // setLoading(false);
      setPaginationCatagories({
        ...pagination,
        total: newData.total_categories,
      }); // Assuming API response contains total count
    } catch (error) {
      console.error("Error fetching data:", error);
      // setLoading(false);
    }
  };
  const FetchDeliveryFee = async () => {
    try {
      const newData = await API_DELIVERY_ORDER({ total_amount: price });
      setDeliveryFee(newData?.delivery_fee);
      console.log("delivery Fee", newData);
    } catch (error) {
      console.error("Error fetching data:", error);
      // setLoading(false);
    }
  };
  const handleScroll = (e) => {
    const { target } = e;
    if (target.scrollTop + target.offsetHeight === target.scrollHeight) {
      if (paginationUser.current < paginationUser.totalPages) {
        setPaginationUser((prevPagination) => ({
          ...prevPagination,
          current: prevPagination.current + 1,
        }));
      }
    }
  };

  // Google Addresses
  const searchAddress = async (address) => {
    // formik.setFieldValue("street_address_camp", address);
    console.log("address", address);
    try {
      const response = await axios.get(
        `${CONSTANTS.BACKEND_URL_PUBLIC}/google/places-autocomplete?query=${address}`
      );
      if (
        response.data.status === "OK" &&
        response.data.predictions.length > 0
      ) {
        const predictions = response.data.predictions;
        setAutocompleteSuggestions(predictions);

        console.log("Address predictions:", predictions);
      } else {
        setAutocompleteSuggestions([]);
        // Handle no results or error cases
        console.error("No address predictions found or error occurred");
      }
    } catch (error) {
      // Handle request error
      console.error("Error fetching data from Google Places API", error);
    }
  };

  const onSelectAddress = async (selectedAddress, setFieldValue) => {
    console.log("selectedAddress", selectedAddress);
    try {
      // Fetch place details using the Place Details request
      const response = await axios.get(`${CONSTANTS.BACKEND_URL_PUBLIC}/google/place-details?place_id=${selectedAddress.place_id}`);
      if (response.data.status === "OK") {
        const placeDetails = response.data.result;
        console.log("Place Details:", placeDetails);
        const postalCode = placeDetails?.address_components?.find((component) =>
          component.types.includes("postal_code")
        )?.long_name;

        const city = placeDetails?.address_components?.find((component) =>
          component.types.includes("locality")
        )?.long_name;

        const state = placeDetails?.address_components?.find((component) =>
          component.types.includes("administrative_area_level_1")
        )?.long_name;

        const country = placeDetails?.address_components?.find((component) =>
          component.types.includes("country")
        )?.long_name;

        // Log all address components
        placeDetails.address_components.forEach((component) => {
          console.log(`${component.types[0]}: ${component.long_name}`);
        });

        // Extract street address
        const streetAddress = placeDetails?.address_components?.find(
          (component) => component.types.includes("route")
        )?.long_name;

        console.log("Street Address:", streetAddress);
        const lat = placeDetails?.geometry?.location?.lat;
        const lng = placeDetails?.geometry?.location?.lng;
        console.log("postalCode", streetAddress);
        // setFieldValue("location", placeDetails?.formatted_address);

        setFieldValue("order_pickup_address.lat", lat);
        setFieldValue("order_pickup_address.lng", lng);
        setFieldValue(
          "order_pickup_address.location",
          selectedAddress?.description
        );
        setFieldValue("order_pickup_address.city", city);
        setFieldValue("order_pickup_address.province", state);
        setFieldValue("order_pickup_address.country", country);
        setFieldValue("order_pickup_address.street", streetAddress);

        setFieldValue("location_lat", lat);
        setFieldValue("location_lng", lng);

        console.log("lat long", lat, lng);
        setAutocompleteSuggestions([]);
      } else {
        console.error("Error fetching place details from Google Places API");
      }

      // Clear the autocomplete suggestions
      setAutocompleteSuggestions([]);
    } catch (error) {
      console.error(
        "Error fetching place details from Google Places API",
        error
      );
    }
  };

  const searchAddressDelivery = async (address) => {
    // formik.setFieldValue("street_address_camp", address);
    console.log("address", address);
    try {
      const response = await axios.get(
        `https://maps.googleapis.com/maps/api/place/autocomplete/json?input=${address}&key=${CONSTANTS?.googleApikey}`
      );
      if (
        response.data.status === "OK" &&
        response.data.predictions.length > 0
      ) {
        const predictions = response.data.predictions;
        setAutocompleteSuggestionsDelevery(predictions);

        console.log("Address predictions:", predictions);
      } else {
        setAutocompleteSuggestionsDelevery([]);
        // Handle no results or error cases
        console.error("No address predictions found or error occurred");
      }
    } catch (error) {
      // Handle request error
      console.error("Error fetching data from Google Places API", error);
    }
  };

  const onSelectAddressDelivery = async (selectedAddress, setFieldValue) => {
    console.log("selectedAddress", selectedAddress);
    try {
      // Fetch place details using the Place Details request
      const response = await axios.get(
        `https://maps.googleapis.com/maps/api/place/details/json?place_id=${selectedAddress.place_id}&key=${CONSTANTS?.googleApikey}`
      );

      if (response.data.status === "OK") {
        const placeDetails = response.data.result;
        console.log("Place Details:", placeDetails);
        const postalCode = placeDetails?.address_components?.find((component) =>
          component.types.includes("postal_code")
        )?.long_name;

        const city = placeDetails?.address_components?.find((component) =>
          component.types.includes("locality")
        )?.long_name;

        const state = placeDetails?.address_components?.find((component) =>
          component.types.includes("administrative_area_level_1")
        )?.long_name;

        const country = placeDetails?.address_components?.find((component) =>
          component.types.includes("country")
        )?.long_name;

        // Log all address components
        placeDetails.address_components.forEach((component) => {
          console.log(`${component.types[0]}: ${component.long_name}`);
        });

        // Extract street address
        const streetAddress = placeDetails?.address_components?.find(
          (component) => component.types.includes("route")
        )?.long_name;

        console.log("Street Address:", streetAddress);
        const lat = placeDetails?.geometry?.location?.lat;
        const lng = placeDetails?.geometry?.location?.lng;
        console.log("postalCode", streetAddress);
        // setFieldValue("location", placeDetails?.formatted_address);
        setFieldValue("order_delivery_address.lat", lat);
        setFieldValue("order_delivery_address.lng", lng);
        setFieldValue(
          "order_delivery_address.location",
          selectedAddress?.description
        );
        setFieldValue("order_delivery_address.city", city);
        setFieldValue("order_delivery_address.province", state);
        setFieldValue("order_delivery_address.country", country);
        setFieldValue("order_delivery_address.street", streetAddress);

        setFieldValue("location_lat", lat);
        setFieldValue("location_lng", lng);
        // setFieldValue('geo',{coordinates:[lat,lng]})
        console.log("lat long", lat, lng);
        setAutocompleteSuggestionsDelevery([]);
      } else {
        console.error("Error fetching place details from Google Places API");
      }

      // Clear the autocomplete suggestions
      setAutocompleteSuggestionsDelevery([]);
    } catch (error) {
      console.error(
        "Error fetching place details from Google Places API",
        error
      );
    }
  };
  // Google Addresses

  useEffect(() => {
    fetchData(pagination.current);
  }, [pagination.current]);

  useEffect(() => {
    fetchUserList();
  }, []);
  useEffect(() => {
    fetchDataItems();
  }, [paginationItems.current, paginationItems.pageSize, searchName]);
  useEffect(() => {
    fetchDataCatagories();
  }, [pagination.current, pagination.pageSize]);

  useEffect(() => {
    FetchDeliveryFee();
  }, [price]);

  
  return (
    <>
      <div className="mb-16 flex h-full w-full items-center justify-center px-2 md:mx-0 md:px-0 lg:mb-10 lg:items-center lg:justify-center">
        <div className="mt-[2vh] w-full max-w-full flex-col items-center md:pl-4 lg:pl-0">
          <Formik
            initialValues={{
              // pending_amount: "",
              // paid_amount: "",
              currency: "SAR",
              order_type: "",
              order_scheme: "normal",
              order_pickup_time: "",
              order_category: "",
              geo:{coordinates:[]}, 
              items: [
                // {
                //   item_id: "",
                //   total_quantity: "",
                //   total_price: "",
                // },
              ],
              order_delivery_time: "",
              order_pickup_address: {
                // building: "",
                // apartment: "",
                // floor: "",
                // street: "",
                // additional_directions: "",
              },
              order_delivery_address: {
                // building: "",
                // apartment: "",
                // floor: "",
                // street: "",
                // additional_directions: "",
              },
              order_note: "",
              is_order_repeated: null,
              order_repeated_cycle: "monthly",
              order_description: "",
              payment_type: "",
              payment_status: null,
              order_provider: "",
              order_user: "",
              description: "",
              total_amount: price,
              coupon_code: "",
            }}
            validationSchema={Yup.object({
              // pending_amount: Yup.number()
              //   .required("Required")
              //   .min(0, "Must be greater than or equal to 0"),
              // paid_amount: Yup.number()
              //   .required("Required")
              //   .min(0, "Must be greater than or equal to 0"),
              currency: Yup.string().required("Required"),
              order_type: Yup.string().required("Required"),
              order_scheme: Yup.string().required("Required"),
              // order_pickup_time: Yup.string().required("Required"),
              // order_delivery_time: Yup.string().required("Required"),
              order_pickup_address: Yup.object().shape({
                // first_name: Yup.string().required("Required"),
                // last_name: Yup.string().required("Required"),
                // phone_no: Yup.string().required("Required"),
                building: Yup.string().required("Required"),
                apartment: Yup.string().required("Required"),
                floor: Yup.string().required("Required"),
                // street: Yup.string().required("Required"),
                // additional_directions: Yup.string().required("Required"),
              }),
              order_delivery_address: Yup.object().shape({
                // first_name: Yup.string().required("Required"),
                // last_name: Yup.string().required("Required"),
                // phone_no: Yup.string().required("Required"),
                building: Yup.string().required("Required"),
                apartment: Yup.string().required("Required"),
                floor: Yup.string().required("Required"),
                // street: Yup.string().required("Required"),
                additional_directions: Yup.string().required("Required"),
              }),
              // order_note: Yup.string().required("Required"),
              // is_order_repeated: Yup.boolean(  ).required("Required"),
              // order_repeated_cycle: Yup.string().required("Required"),
              order_description: Yup.string().required("Required"),
              payment_type: Yup.string().required("Required"),
              payment_status: Yup.string().required("Required"),
              order_provider: Yup.string().required("Required"),
              order_user: Yup.string().required("Required"),
              description: Yup.string().required("Required"),
              // items: Yup.array().of(
              //   Yup.object().shape({
              //     category_id: Yup.string().required("Required"),
              //     item_id: Yup.string().required("Required"),
              //     total_quantity: Yup.number()
              //       .required("Required")
              //       .min(1, "Must be greater than or equal to 1"),
              //     total_price: Yup.number()
              //       .required("Required")
              //       .min(0, "Must be greater than or equal to 0"),
              //   })
              // ),
            })}
            onSubmit={async (values, { setSubmitting }) => {
              try {
                // getDetail => loop

                // const selectedObjects = itemOptions?.items?.filter((item) =>
                //   item?.item_service.some((service) =>
                //     selectedItems.includes(service.item_service)
                //   )
                // );
                // console.log("selectedObjects", selectedObjects);
                // Step 1: Filter the items by comparing their item_service values with the selected item_service IDs
                const selectedObjects = itemOptions?.items?.filter((item) =>
                  item?.item_service.some((service) =>
                    selectedItems.includes(service.item_service)
                  )
                );
                console.log("selectedObjects", selectedObjects);

                // Step 2: Prepare the payload
                const items = selectedObjects.map((item) => {
                  const total_quantity = item.item_service.length;
                  const total_price = item.item_service.reduce(
                    (sum, service) => sum + parseFloat(service.price),
                    0
                  );
                  setPrice(total_price);
                  return {
                    category_id: item?.category, // Assuming category_id is same as item _id
                    item_id: item?._id, // Assuming item_id is same as item _id
                    total_quantity: total_quantity,
                    total_price: total_price,
                  };
                });

                const payload = {
                  ...values,
                  order_delivery_time: {
                    from: moment(startDateDelivery).unix(),
                    to: moment(endDateDelivery).unix(),
                  },
                  order_pickup_time: {
                    from: moment(startDatePickup).unix(),
                    to: moment(endDatePickup).unix(),
                  },

                  // order_pickup_time: moment(values.order_pickup_time).unix(),
                  // order_delivery_time: moment(
                  //   values.order_delivery_time
                  // ).unix(),

                  items: items,
                  delivery_fee: deliveryFee,
                  total_items: items.length,
                  total: price + deliveryFee,
                  sub_total: price,
                };
                const response = await API_CREATE_ORDER(payload);
                toast.success(response.message);
                navigate("/admin/order-management/order-tables");
              } catch (error) {
                console.error("error", error);
                toast.error(error?.response?.data?.message);
              } finally {
                setSubmitting(false);
              }
            }}
          >
            {({ values, setFieldValue, errors, isSubmitting }) => (
              <Form className="flex min-h-[36rem] w-full flex-col justify-between rounded-[20px] bg-white p-8 shadow-md">
                {console.log("error ==>", errors, values)}
                <Row gutter={[16, 16]}>
                  {/* <Col span={12}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {t("Pending Amount")}
                        <span className="text-[red]">*</span>
                      </label>
                      <Field
                        className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none"
                        type="number"
                        name="pending_amount"
                        placeholder={t("Pending Amount")}
                      />

                      <ErrorMessage
                        name="pending_amount"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>

                  <Col span={12}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {t("Paid Amount")}
                        <span className="text-[red]">*</span>
                      </label>
                      <Field
                        className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none"
                        type="number"
                        name="paid_amount"
                        placeholder={t("Paid Amount")}
                      />
                      <ErrorMessage
                        name="paid_amount"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col> */}

                  <Col span={12}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {t("Currency")}
                        <span className="text-[red]">*</span>
                      </label>
                      <Field
                        as={Select}
                        className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none"
                        name="currency"
                        placeholder={t("Currency")}
                        onChange={(value) => setFieldValue("currency", value)}
                      >
                        <Option value="" disabled>
                          Select Currency
                        </Option>

                        <Option value="USD">USD</Option>
                        <Option value="SAR">SAR</Option>
                      </Field>
                      <ErrorMessage
                        name="currency"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>

                  <Col span={12}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {t("Order Type")}
                        <span className="text-[red]">*</span>
                      </label>
                      <Field
                        as={Select}
                        className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none"
                        name="order_type"
                        placeholder={t("Order Type")}
                        onChange={(value) => setFieldValue("order_type", value)}
                      >
                        <Option value="" disabled>
                          Select order Type
                        </Option>
                        <Option value="normal">Normal</Option>
                        <Option value="express">Express</Option>
                        {/* <Option value="vip">VIP</Option>
                        <Option value="personal">Personal</Option>
                        <Option value="box">Box</Option> */}
                      </Field>
                      <ErrorMessage
                        name="order_type"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>

                  {/* <Col span={12}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {t("Order Scheme")}
                        <span className="text-[red]">*</span>
                      </label>
                      <Field
                        as={Select}
                        className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none"
                        name="order_scheme"
                        placeholder={t("Order Scheme")}
                        onChange={(value) =>
                          setFieldValue("order_scheme", value)
                        }
                      >
                        <Option value="skip_basket">Skip Basket</Option>
                        <Option value="normal">Normal</Option>
                      </Field>
                      <ErrorMessage
                        name="order_scheme"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col> */}

                  <Col span={12}>
                    <div className="mb-3 flex flex-col">
                      <label className="font-semibold">
                        {t("Order Pickup Time")}
                        <span className="text-[red]">*</span>
                      </label>

                      <div className="picks flex gap-3">
                        <DatePicker
                          className="w-100  mt-2 h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm  outline-none"
                          selected={
                            startDatePickup ? new Date(startDatePickup) : null
                          }
                          onChange={(date) => setStartDatePickup(date)}
                          showTimeSelect
                          timeFormat="HH:mm"
                          timeIntervals={15}
                          dateFormat="yyyy-MM-dd HH:mm"
                          placeholderText="From pickup time"
                        />

                        <DatePicker
                          className="w-100  mt-2 h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none"
                          selected={
                            endDatePickup ? new Date(endDatePickup) : null
                          }
                          onChange={(date) => setEndDatePickup(date)}
                          showTimeSelect
                          timeFormat="HH:mm"
                          timeIntervals={15}
                          dateFormat="yyyy-MM-dd HH:mm"
                          placeholderText="To pickup time"
                        />
                      </div>

                      {/* <RangePicker

                        onChange={(dates) => {
                          setStartDatePickup(dates ? dates[0] : null);
                          setEndDatePickup(dates ? dates[1] : null);
                        }}
                        showTime={{ format: "HH:mm" }}
                        format="YYYY-MM-DD HH:mm"
                      /> */}
                      {/* <Field name="order_pickup_time">
                        {({ field }) => (
                          <DatePicker
                            className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none"
                            selected={
                              field.value ? new Date(field.value) : null
                            }
                            onChange={(date) =>
                              setFieldValue("order_pickup_time", date)
                            }
                            showTimeSelect
                            timeFormat="HH:mm"
                            timeIntervals={15}
                            dateFormat="yyyy-MM-dd HH:mm"
                            placeholderText="Select pickup time"
                          />
                        )}
                      </Field> */}
                      {/* <Field
                        as={DatePicker}
                        showTime
                        className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none"
                        name="order_pickup_time"
                        onChange={(value) =>
                          setFieldValue("order_pickup_time", value)
                        }
                        format="YYYY-MM-DD HH:mm:ss"
                        placeholder={t("Order Pickup Time")}
                      /> */}
                      <ErrorMessage
                        name="order_pickup_time"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>
                  <Col span={12}>
                    <div className="mb-3 flex flex-col">
                      <label className="font-semibold">
                        {t("Order Delivery Time")}
                        <span className="text-[red]">*</span>
                      </label>
                      <div className="picks flex gap-3">
                        <DatePicker
                          className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none"
                          selected={
                            startDateDelivery
                              ? new Date(startDateDelivery)
                              : null
                          }
                          onChange={(date) => setStartDateDelivery(date)}
                          showTimeSelect
                          timeFormat="HH:mm"
                          timeIntervals={15}
                          dateFormat="yyyy-MM-dd HH:mm"
                          placeholderText="From Delivery time"
                        />

                        <DatePicker
                          className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none"
                          selected={
                            endDateDelivery ? new Date(endDateDelivery) : null
                          }
                          onChange={(date) => setEndDateDelivey(date)}
                          showTimeSelect
                          timeFormat="HH:mm"
                          timeIntervals={15}
                          dateFormat="yyyy-MM-dd HH:mm"
                          placeholderText="To Delivery time"
                        />
                      </div>
                      {/* <RangePicker
                        onChange={(dates) => {
                          setStartDateDelivery(dates ? dates[0] : null);
                          setEndDateDelivey(dates ? dates[1] : null);
                        }}
                        showTime={{ format: "HH:mm" }}
                        format="YYYY-MM-DD HH:mm"
                      /> */}
                      {/* <Field name="order_delivery_time">
                        {({ field }) => (
                          <DatePicker
                            className="mt-2  h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none"
                            selected={
                              field.value ? new Date(field.value) : null
                            }
                            onChange={(date) =>
                              setFieldValue("order_delivery_time", date)
                            }
                            showTimeSelect
                            timeFormat="HH:mm"
                            timeIntervals={15}
                            dateFormat="yyyy-MM-dd HH:mm"
                            placeholderText="Select Delivery time"
                          />
                        )}
                      </Field> */}

                      <ErrorMessage
                        name="order_delivery_time"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>
                  <Col span={12}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {t("Order Pickup Address")}
                        <span className="text-[red]">*</span>
                      </label>
                    </div>
                    <TextareaField
                      className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none  "
                      name="order_pickup_address.location"
                      placeholder={t("location")}
                      value={values?.order_pickup_address.location}
                      handleChange={(e) => {
                        const addressInput = e.target.value;
                        setFieldValue(
                          "order_pickup_address.location",
                          addressInput
                        );
                        searchAddress(addressInput); // Call the address autocomplete function
                      }}
                    />
                    <ErrorMessage
                      name="order_pickup_address.location"
                      component="div"
                      className="text-red-500"
                    />
                    {autocompleteSuggestions.length > 0 && (
                      <AddressAutocomplete
                        suggestions={autocompleteSuggestions}
                        onSelectAddress={(address) =>
                          onSelectAddress(address, setFieldValue)
                        }
                      />
                    )}

                    {/* new */}
                    <div className="mb-3">
                      {/* <label className="font-semibold">{t("Building")}</label> */}
                      <Field
                        className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none  "
                        type="text"
                        name="order_pickup_address.building"
                        placeholder={t("Building")}
                      />
                      <ErrorMessage
                        name="order_pickup_address.building"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                    <div className="mb-3">
                      {/* <label className="font-semibold">{t("Apartment")}</label> */}
                      <Field
                        className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none  "
                        type="text"
                        name="order_pickup_address.apartment"
                        placeholder={t("Apartment")}
                      />
                      <ErrorMessage
                        name="order_pickup_address.apartment"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                    <div className="mb-3">
                      {/* <label className="font-semibold">{t("Floor")}</label> */}
                      <Field
                        className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none  "
                        type="text"
                        name="order_pickup_address.floor"
                        placeholder={t("Floor")}
                      />
                      <ErrorMessage
                        name="order_pickup_address.floor"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                    <div className="mb-3">
                      {/* <label className="font-semibold">{t("Street")}</label> */}
                      <Field
                        className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none  "
                        type="text"
                        name="order_pickup_address.street"
                        placeholder={t("Street")}
                      />
                      <ErrorMessage
                        name="order_pickup_address.street"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                    <div className="mb-3">
                      {/* <label className="font-semibold">{t("City")}</label> */}
                      <Field
                        className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none  "
                        type="text"
                        name="order_pickup_address.city"
                        placeholder={t("City")}
                        maxLength={20}
                      />
                      <ErrorMessage
                        name="order_pickup_address.city"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                    <div className="mb-3">
                      {/* <label className="font-semibold">{t("Province")}</label> */}
                      <Field
                        className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none  "
                        type="text"
                        name="order_pickup_address.province"
                        placeholder={t("Province")}
                        maxLength={20}
                        onKeyPress={(event) => {
                          const charCode = event.charCode;
                          if (
                            !(charCode >= 65 && charCode <= 90) && // A-Z
                            !(charCode >= 97 && charCode <= 122) && // a-z
                            charCode !== 32 // space
                          ) {
                            event.preventDefault();
                          }
                        }}
                      />
                      <ErrorMessage
                        name="order_pickup_address.province"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                    <div className="mb-3">
                      {/* <label className="font-semibold">{t("Country")}</label> */}
                      <Field
                        className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none  "
                        type="text"
                        name="order_pickup_address.country"
                        placeholder={t("Country")}
                      />
                      <ErrorMessage
                        name="order_pickup_address.country"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                    <div className="mb-3">
                      {/* <label className="font-semibold">
                        {t("Additional Directions")}
                      </label> */}
                      <Field
                        className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none  "
                        type="text"
                        name="order_pickup_address.additional_directions"
                        placeholder={t("Additional Directions")}
                      />
                      <ErrorMessage
                        name="order_pickup_address.additional_directions"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                    {/* new */}

                    {/* <Field
                      className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none"
                      type="text"
                      name="order_pickup_address.building"
                      placeholder={t("Building")}
                    />
                    <ErrorMessage
                      name="order_pickup_address.building"
                      component="div"
                      className="text-red-500"
                    />
                    <Field
                      className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none"
                      type="text"
                      name="order_pickup_address.apartment"
                      placeholder={t("Apartment")}
                    />
                    <ErrorMessage
                      name="order_pickup_address.apartment"
                      component="div"
                      className="text-red-500"
                    />
                    <Field
                      className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none"
                      type="text"
                      name="order_pickup_address.floor"
                      placeholder={t("Floor")}
                    />
                    <ErrorMessage
                      name="order_pickup_address.floor"
                      component="div"
                      className="text-red-500"
                    />
                    <Field
                      className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none"
                      type="text"
                      name="order_pickup_address.street"
                      placeholder={t("Street")}
                    />
                    <ErrorMessage
                      name="order_pickup_address.street"
                      component="div"
                      className="text-red-500"
                    />

                    <Field
                      className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none"
                      type="text"
                      name="order_pickup_address.additional_directions"
                      placeholder={t("Additional Directions")}
                    />
                    <ErrorMessage
                      name="order_pickup_address.additional_directions"
                      component="div"
                      className="text-red-500"
                    /> */}
                  </Col>

                  <Col span={12}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {t("Order Delivery Address")}
                        <span className="text-[red]">*</span>
                      </label>
                    </div>
                    <TextareaField
                      className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none  "
                      // label={t("Street")}
                      name="order_delivery_address.location"
                      placeholder={t("location")}
                      value={values?.order_delivery_address.location}
                      handleChange={(e) => {
                        const addressInput = e.target.value;
                        setFieldValue("order_delivery_address.location", addressInput);
                        searchAddressDelivery(addressInput);
                      }}
                    />
                    <ErrorMessage
                      name="order_delivery_address.location"
                      component="div"
                      className="text-red-500"
                    />
                    {autocompleteSuggestionsDelevery.length > 0 && (
                      <AddressAutocomplete
                        suggestions={autocompleteSuggestionsDelevery}
                        // onSelectAddress={onSelectAddress}
                        onSelectAddress={(address) =>
                          onSelectAddressDelivery(address, setFieldValue)
                        }
                      />
                    )}
                    {/* <Field
                      className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none"
                      type="text"
                      name="order_delivery_address.building"
                      placeholder={t("Building")}
                    />
                    <ErrorMessage
                      name="order_delivery_address.building"
                      component="div"
                      className="text-red-500"
                    />
                    <Field
                      className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none"
                      type="text"
                      name="order_delivery_address.apartment"
                      placeholder={t("Apartment")}
                    />
                    <ErrorMessage
                      name="order_delivery_address.apartment"
                      component="div"
                      className="text-red-500"
                    />
                    <Field
                      className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none"
                      type="text"
                      name="order_delivery_address.floor"
                      placeholder={t("Floor")}
                    />
                    <ErrorMessage
                      name="order_delivery_address.floor"
                      component="div"
                      className="text-red-500"
                    />
                    <Field
                      className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none"
                      type="text"
                      name="order_delivery_address.street"
                      placeholder={t("Street")}
                    />
                    <ErrorMessage
                      name="order_delivery_address.street"
                      component="div"
                      className="text-red-500"
                    />

                    <Field
                      className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none"
                      type="text"
                      name="order_delivery_address.additional_directions"
                      placeholder={t("Additional Directions")}
                    />
                    <ErrorMessage
                      name="order_delivery_address.additional_directions"
                      component="div"
                      className="text-red-500"
                    /> */}

                    {/* new */}
                    <div className="mb-3">
                      {/* <label className="font-semibold">{t("Building")}</label> */}
                      <Field
                        className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none  "
                        type="text"
                        name="order_delivery_address.building"
                        placeholder={t("Building")}
                      />
                      <ErrorMessage
                        name="order_delivery_address.building"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                    <div className="mb-3">
                      {/* <label className="font-semibold">{t("Apartment")}</label> */}
                      <Field
                        className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none  "
                        type="text"
                        name="order_delivery_address.apartment"
                        placeholder={t("Apartment")}
                      />
                      <ErrorMessage
                        name="order_delivery_address.apartment"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                    <div className="mb-3">
                      {/* <label className="font-semibold">{t("Floor")}</label> */}
                      <Field
                        className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none  "
                        type="text"
                        name="order_delivery_address.floor"
                        placeholder={t("Floor")}
                      />
                      <ErrorMessage
                        name="order_delivery_address.floor"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                    <div className="mb-3">
                      {/* <label className="font-semibold">{t("Street")}</label> */}
                      <Field
                        className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none  "
                        type="text"
                        name="order_delivery_address.street"
                        placeholder={t("Street")}
                      />
                      <ErrorMessage
                        name="order_delivery_address.street"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                    <div className="mb-3">
                      {/* <label className="font-semibold">{t("City")}</label> */}
                      <Field
                        className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none  "
                        type="text"
                        name="order_delivery_address.city"
                        placeholder={t("City")}
                        maxLength={20}
                      />
                      <ErrorMessage
                        name="order_delivery_address.city"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                    <div className="mb-3">
                      {/* <label className="font-semibold">{t("Province")}</label> */}
                      <Field
                        className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none  "
                        type="text"
                        name="order_delivery_address.province"
                        placeholder={t("Province")}
                        maxLength={20}
                        onKeyPress={(event) => {
                          const charCode = event.charCode;
                          if (
                            !(charCode >= 65 && charCode <= 90) && // A-Z
                            !(charCode >= 97 && charCode <= 122) && // a-z
                            charCode !== 32 // space
                          ) {
                            event.preventDefault();
                          }
                        }}
                      />
                      <ErrorMessage
                        name="order_delivery_address.province"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                    <div className="mb-3">
                      {/* <label className="font-semibold">{t("Country")}</label> */}
                      <Field
                        className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none  "
                        type="text"
                        name="order_delivery_address.country"
                        placeholder={t("Country")}
                      />
                      <ErrorMessage
                        name="order_delivery_address.country"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                    <div className="mb-3">
                      {/* <label className="font-semibold">
                        {t("Additional Directions")}
                      </label> */}
                      <Field
                        className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none  "
                        type="text"
                        name="order_delivery_address.additional_directions"
                        placeholder={t("Additional Directions")}
                      />
                      <ErrorMessage
                        name="order_delivery_address.additional_directions"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                    {/* new */}
                  </Col>

                  <Col span={12}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {t("Is Order Repeated")}
                        {/* <span className="text-[red]">*</span> */}
                      </label>
                      <Field
                        as={Select}
                        className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none"
                        name="is_order_repeated"
                        placeholder={t("Is Order Repeated")}
                        onChange={(value) =>
                          setFieldValue("is_order_repeated", value)
                        }
                      >
                        <Option value="" disabled>
                          Is Order Repeated
                        </Option>

                        <Option value={true}>Yes</Option>
                        <Option value={false}>No</Option>
                      </Field>
                      <ErrorMessage
                        name="is_order_repeated"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>

                  <Col span={12}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {t("Order Repeated Cycle")}
                        {/* <span className="text-[red]">*</span> */}
                      </label>
                      <Field
                        as={Select}
                        className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none"
                        name="order_repeated_cycle"
                        placeholder={t("Order Repeated Cycle")}
                        onChange={(value) =>
                          setFieldValue("order_repeated_cycle", value)
                        }
                      >
                        <Option value="" disabled>
                          Select Order Repeated Cycle
                        </Option>

                        <Option value="weekly">Weekly</Option>
                        <Option value="monthly">Monthly</Option>
                      </Field>
                      <ErrorMessage
                        name="order_repeated_cycle"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>
                  <Col span={12}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {t("Order Note")}
                        {/* <span className="text-[red]">*</span> */}
                      </label>
                      <Field
                        as="textarea"
                        rows={4}
                        className="mt-2 w-full rounded-xl border bg-white p-3 text-sm outline-none"
                        type="text"
                        name="order_note"
                        placeholder={t("Order Note")}
                      />
                      <ErrorMessage
                        name="order_note"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>
                  <Col span={12}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {t("Order Description")}
                        <span className="text-[red]">*</span>
                      </label>
                      <Field
                        as="textarea"
                        rows={4}
                        className="mt-2 w-full rounded-xl border bg-white p-3 text-sm outline-none"
                        type="text"
                        name="order_description"
                        placeholder={t("Order Description")}
                      />
                      <ErrorMessage
                        name="order_description"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>

                  <Col span={12}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {t("Payment Type")}
                        <span className="text-[red]">*</span>
                      </label>
                      <Field
                        as={Select}
                        className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none"
                        name="payment_type"
                        placeholder={t("Payment Type")}
                        onChange={(value) =>
                          setFieldValue("payment_type", value)
                        }
                      >
                        <Option value="" disabled>
                          Payment Type
                        </Option>

                        <Option value="credit_card">Credit Card</Option>
                        <Option value="cod">COD</Option>
                      </Field>
                      <ErrorMessage
                        name="payment_type"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>

                  <Col span={12}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {t("Payment Status")}
                        <span className="text-[red]">*</span>
                      </label>
                      <Field
                        as={Select}
                        className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none"
                        name="payment_status"
                        placeholder={t("Payment Status")}
                        onChange={(value) =>
                          setFieldValue("payment_status", value)
                        }
                      >
                        <Option value="" disabled>
                          Select Payment Status
                        </Option>

                        <Option value="paid">Paid</Option>
                        <Option value="unpaid">Unpaid</Option>
                      </Field>
                      <ErrorMessage
                        name="payment_status"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>

                  <Col span={12}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {t("Select Catagory")}
                        <span className="text-[red]">*</span>
                      </label>
                      <Field
                        as={Select}
                        className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none"
                        name="order_category"
                        placeholder={t("Select Catagory")}
                        onChange={(value) => {
                          // setFieldValue("items", value);
                          setFieldValue("order_category", value);
                          setSearchName(value);
                        }}
                      >
                        <Option value="" disabled>
                          Select Catagory
                        </Option>
                        {categoryOptions?.categories?.map((catagory) => (
                          <Option key={catagory._id} value={catagory?._id}>
                            {catagory?.title}
                          </Option>
                        ))}
                      </Field>
                      <ErrorMessage
                        name="order_category"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>

                  <Col span={12}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {t("Items")}
                        <span className="text-[red]">*</span>
                      </label>
                      <Field
                        as={TreeSelect}
                        disabled={!values?.order_category}
                        className="mt-2  h-11 w-full  rounded-xl border bg-white p-3 text-sm outline-none"
                        name="items"
                        placeholder={t("Order Provider")}
                        treeData={itemOptions?.items?.map((provider) => ({
                          title: provider?.name,
                          value: provider?._id,
                          key: provider?._id,
                          children: provider?.item_service?.map((service) => ({
                            title: service?.service_info?.name,
                            value: service?.service_info?._id,
                            key: service?.service_info?._id,
                          })),
                        }))}
                        treeCheckable={true}
                        showCheckedStrategy={TreeSelect.SHOW_CHILD}
                        onChange={(value) => {
                          setFieldValue("items", value);
                          setSelectedItems(value);

                          // new
                          // Initialize an empty array for selected items
                          let selectedItemsArray = [];

                          // Push selected values into the selectedItemsArray
                          value.forEach((val) => {
                            selectedItemsArray.push(val);
                          });
                          const selectedObjects = itemOptions?.items?.filter(
                            (item) =>
                              item?.item_service.some((service) =>
                                selectedItemsArray?.includes(
                                  service.item_service
                                )
                              )
                          );
                          // Step 2: Prepare the payload
                          const items = selectedObjects.map((item) => {
                            const total_quantity = item.item_service.length;
                            const total_price = item.item_service.reduce(
                              (sum, service) => sum + parseFloat(service.price),
                              0
                            );
                            setPrice(total_price);
                            return {
                              category_id: item?.category, // Assuming category_id is same as item _id
                              item_id: item?._id, // Assuming item_id is same as item _id
                              total_quantity: total_quantity,
                              total_price: total_price,
                            };
                          });
                          // Calculate the total sum of 'total_price'
                          const totalPriceSum = items?.reduce(
                            (accumulator, currentValue) => {
                              return accumulator + currentValue.total_price;
                            },
                            0
                          );
                          setPrice(totalPriceSum);
                          
                        }}
                        onSelect={(value) => {
                          // setFieldValue("items", value);
                          console.log({ Treee: value });
                        }}
                        style={{ width: "100%" }}
                      >
                        <Option value="" disabled>
                          Select Items
                        </Option>

                        {itemOptions?.items?.map((item) => (
                          <Option key={item._id} value={item._id}>
                            {item?.name}
                          </Option>
                        ))}
                      </Field>
                    </div>
                  </Col>

                  
                 
                   <Col span={12}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {t("Order Store")}
                        <span className="text-[red]">*</span>
                      </label>
                      <Field
                        as={Select}
                        className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none"
                        name="order_provider"
                        placeholder={t("Order Provider")}
                        onChange={(value) => setFieldValue("order_provider", value)}>
                        <Option value="" disabled>
                          Select Store
                        </Option>
                        {providerOptions?.map((provider) => (
                          <Option key={provider._id} value={provider._id}>
                            {provider?.store_name}
                          </Option>
                        ))}
                      </Field>
                      <ErrorMessage
                        name="order_provider"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col> 
                

                  <Col span={11}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {t("Order User")}
                        <span className="text-[red]">*</span>
                      </label>
                      {/* <Field
                        as={Select}
                        showSearch
                        className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none"
                        name="order_user"
                        placeholder={t("Order User")}
                        onChange={(value) => setFieldValue("order_user", value)}
                        filterOption={(input, option) =>
                          option.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        
                      >
                        <Option value="" disabled>
                          Select user
                        </Option>
                        {(!userOptions || userOptions.length === 0) && (
                          <Option key="modalButton" onClick={handleModalOpen}>
                            No users available. Click to add user.
                          </Option>
                        )}
                        {userOptions?.map((user) => (
                          <Option key={user._id} value={user._id}>
                            {user.first_name}
                          </Option>
                        ))}
                      </Field> */}
                      <Select
                        className="mt-2  h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none"
                        placeholder="Select User"
                        onChange={(value) => setFieldValue("order_user", value)}
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          option.children
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                        onDropdownVisibleChange={(open) => {
                          if (
                            open &&
                            paginationUser.current < paginationUser.totalPages
                          ) {
                            fetchUserList(
                              paginationUser.current + 1,
                              paginationUser.pageSize
                            );
                          }
                        }}
                        onPopupScroll={(e) => {
                          const { target } = e;
                          if (
                            target.scrollTop + target.offsetHeight ===
                            target.scrollHeight
                          ) {
                            if (
                              paginationUser.current < paginationUser.totalPages
                            ) {
                              fetchUserList(
                                paginationUser.current + 1,
                                paginationUser.pageSize
                              );
                            }
                          }
                        }}
                        loading={loadingUser}
                      >
                        {userOptions?.map((user) => (
                          <Option key={user?.id} value={user?._id}>
                            {user?.first_name}
                          </Option>
                        ))}
                      </Select>
                      <ErrorMessage
                        name="order_user"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>
                  <Col span={1} className="mt-2 flex items-center pl-0">
                    <button
                      type="button"
                      className={`hover:bg-white-700 
                        rounded
                       bg-yellow-500 px-4 py-1 font-bold text-white`}
                      onClick={() => {
                        setModalVisible(true);
                      }}
                    >
                      Add User
                    </button>{" "}
                  </Col>

                  <Col span={12}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {t("Description")}
                        <span className="text-[red]">*</span>
                      </label>
                      <Field
                        as="textarea"
                        rows={4}
                        className="mt-2 w-full rounded-xl border bg-white p-3 text-sm outline-none"
                        type="text"
                        name="description"
                        placeholder={t("Description")}
                      />
                      <ErrorMessage
                        name="description"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>

                  <Col span={12} className="flex items-center justify-center">
                    {/* {price && (
                      <div className="mb-3">
                        <h1 className="mb-[2px] text-2xl">
                          Amount :{" "}
                          <span className="font-medium">
                            {(values?.currency == "USD"
                              ? "$"
                              : values?.currency) + price}
                          </span>
                        </h1>
                        {couponData && (
                          <h1 className="mb-[2px] text-2xl">
                            Discount :{" "}
                            <span className="font-medium">
                              {(values?.currency == "USD"
                                ? "$"
                                : values?.currency) + couponData}
                            </span>
                          </h1>
                        )}

                        {couponData && price && (
                          <h1 className="mb-[2px] text-2xl">
                            Total :{" "}
                            <span className="font-medium">
                              {(values?.currency == "USD"
                                ? "$"
                                : values?.currency) +
                                (Number(price) - Number(couponData)).toFixed(2)}
                            </span>
                          </h1>
                        )}
                      </div>
                    )} */}

                    <Card
                      title="Order Summary"
                      className="flex min-w-96   flex-col items-center justify-center"
                      bordered
                    >
                      <div>
                        {/* <p>Subtotal (1 items) Rs. 349</p> */}
                        {price && (
                          <p>
                            Amount :{" "}
                            <span className="font-medium">
                              {(values?.currency == "USD"
                                ? "$"
                                : values?.currency) + price}
                            </span>
                          </p>
                        )}
                        {deliveryFee && (
                          <p>
                            Shipping Fee{" "}
                            <span className="font-medium">
                              {(values?.currency == "USD"
                                ? "$"
                                : values?.currency) + deliveryFee}
                            </span>
                          </p>
                        )}
                        {deliveryFee && price && (
                          <p>
                            Sub Total{" "}
                            <span className="font-medium">
                              {(values?.currency == "USD"
                                ? "$"
                                : values?.currency) + Number(price)}
                            </span>
                          </p>
                        )}
                        <div className="mt-2 flex">
                          <Field
                            className=" w-full border bg-white p-3 text-sm outline-none"
                            type="text"
                            name="coupon_code"
                            placeholder={t("Coupon Code")}
                          />
                          <ErrorMessage
                            name="coupon_code"
                            component="div"
                            className="text-red-500"
                          />
                          <button
                            type="button"
                            className={`rounded ${
                              couponData ? "bg-green-500" : "bg-yellow-500"
                            } hover:bg-white-700 px-4 py-1 font-bold text-white`}
                            onClick={() =>
                              handleApplyCoupon(
                                values?.coupon_code,
                                values?.total_amount
                              )
                            }
                            // disabled={couponData}
                          >
                            Apply
                            {/* {couponData ? "Applied" : "Apply"}{" "}
                            {couponData ? "✅" : ""} */}
                          </button>{" "}
                        </div>
                        {/* <p style={{ color: "red" }}>
                        Sorry, this voucher is not valid.
                      </p> */}
                        {/* {couponData && (
                          <p>
                            Discount :{" "}
                            <span className="font-medium">
                              {(values?.currency == "USD"
                                ? "$"
                                : values?.currency) + couponData}
                            </span>
                          </p>
                        )} */}
                        {/* {couponData && price && (
                          <p>
                            Total :{" "}
                            <span className="font-medium">
                              {(values?.currency == "USD"
                                ? "$"
                                : values?.currency) +
                                (Number(price) - Number(couponData)).toFixed(2)}
                            </span>
                          </p>
                        )} */}
                        <p>
                          Total :{" "}
                          <span className="font-medium">
                            {(values?.currency == "USD"
                              ? "$"
                              : values?.currency) +
                              (couponData
                                ? couponData
                                : Number(deliveryFee) + Number(price))}
                          </span>
                        </p>
                      </div>
                    </Card>
                  </Col>
                </Row>

                <div className="w-100 mt-6 flex justify-end">
                  <button
                    type="submit" disabled={isSubmitting} className="linear mt-2 w-full max-w-[11rem] rounded-xl bg-brand-500 px-8 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"> {isSubmitting ? t("Creating...") : t("Create Order")}
                  </button>
                </div>
              </Form>
            )}
          </Formik>

          <Modal
            // key={selectedStore?._id}
            visible={modalVisible}
            onOk={() => setModalVisible(false)}
            onCancel={() => setModalVisible(false)}
            style={{ minWidth: "67rem" }}
            className="order-modal"
          >
            <CreateOrderUser
              onSuccessModal={() => {
                setModalVisible(false);
                fetchUserList();
              }}
            />
          </Modal>

          {/* <Modal
            title="Add User"
            visible={modalVisible}
            onCancel={() => setModalVisible(false)}
            footer={null}
          >
            <p>Modal content for adding user.</p>
          </Modal> */}
        </div>
      </div>
      {/* <ToastContainer position="top-right" /> */}
    </>
  );
};
export default CreateOrder;
